/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourtsService {
    /**
     * List all courts
     * Get a paginated list of courts for the authenticated user
     * @param courtTypeId Filter by court type ID
     * @param isActive Filter by active status
     * @param search Search by court name
     * @returns any List of courts
     * @throws ApiError
     */
    public static ae0F3Cffb80Ac352Ec96485D6095183(
        courtTypeId?: number,
        isActive?: 'Yes' | 'No',
        search?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courts',
            query: {
                'court_type_id': courtTypeId,
                'is_active': isActive,
                'search': search,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new court
     * Create a new court
     * @param requestBody
     * @returns any Court created successfully
     * @throws ApiError
     */
    public static c80Df7B043816Cfbee1D634Fa6A2A16E(
        requestBody: {
            court_type_id: number;
            court_name: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/courts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific court
     * Retrieve details of a specific court
     * @param id Court ID
     * @returns any Court details
     * @throws ApiError
     */
    public static e084Abdab84E8424Ff023E7F9E2Ea095(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court not found`,
            },
        });
    }
    /**
     * Update a court
     * Update an existing court
     * @param id Court ID
     * @param requestBody
     * @returns any Court updated successfully
     * @throws ApiError
     */
    public static e3882Ca58A4Fc26E29A005E89D2096(
        id: number,
        requestBody: {
            court_type_id?: number;
            court_name?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/courts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Court not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a court
     * Delete a court
     * @param id Court ID
     * @returns any Court deleted successfully
     * @throws ApiError
     */
    public static ae40E1Abb6443D5519A7716084Da1C(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/courts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court not found`,
            },
        });
    }
}
